import { ChainId } from '@src/configs/chainInfo'
import { IExchangeData } from '@src/types/exchange'
import { isFeatureEnabled } from '@src/utils/environment'

// EVM Chain Utilities
export const isEVMChain = (chainId: number | string): boolean => {
    const nonEVMChains = [ChainId.Solana, ChainId.Tron]
    return !nonEVMChains.includes(+chainId)
}

export const isOriginEVM = (networkId: number | string): boolean => {
    return isEVMChain(networkId)
}

export const isCrossChainEVMNonEVM = (sellChainId: number | string, buyChainId: number | string): boolean => {
    return isEVMChain(sellChainId) !== isEVMChain(buyChainId)
}

// Solana Chain Utilities
export const isOriginSolana = (networkId: number | string): boolean => {
    return +networkId === ChainId.Solana
}

export const isDestinationSolana = (networkId: number | string): boolean => {
    return +networkId === ChainId.Solana
}

// Tron Chain Utilities
export const isOriginTron = (networkId: number | string): boolean => {
    return +networkId === ChainId.Tron
}

export const isDestinationTron = (networkId: number | string): boolean => {
    return +networkId === ChainId.Tron
}

// Chain Restriction Utilities
export const getDisabledChains = (sellData: IExchangeData, buyData: IExchangeData) => {
    return [+sellData.chainId]
}
